<template>
  <!-- Wrapper for all Itinerary components -->
  <div id="itineraries-container">
    <!-- Pass in information for Country level -->
    <div v-if="level === 'country' || level === 'territory'">
      <ItineraryList :current="current" :next="next"></ItineraryList>
    </div>
    <!-- Pass in information for Itinerary level -->
    <div v-else-if="level === 'itinerary'">
      <SubItineraryList :current="current" :next="next"></SubItineraryList>
    </div>
    <!-- Pass in information for Sub-Itinerary level -->
    <div v-else-if="level === 'sub-itinerary'">
      <SubItinerary
        :current="current"
        :next="next"
        :index="index"
        :locationId="locationId"
        @location-change="locationEmit"
      >
      </SubItinerary>
    </div>
  </div>
</template>

<script>
import ItineraryList from "./ItineraryList.vue";
import SubItineraryList from "./SubItineraryList.vue";
import SubItinerary from "./SubItinerary.vue";
export default {
  name: "ItinerariesComponent",
  components: {
    ItineraryList: ItineraryList,
    SubItineraryList: SubItineraryList,
    SubItinerary: SubItinerary,
  },
  props: ["level", "current", "next", "index", "locationId"],
  methods: {
    // Emit Location changes
    locationEmit: function (index) {
      this.$emit("location-change", index);
    },
  },
};
</script>
